define((require) => {
    "use strict";

    const Backbone = require("backbone");
    const Configuration = require("shared/services/Configuration");
    const MsCompanyModel = require("ui/experienceOverview/experiencePermissions/MsCompanyModel");

    /**
     * An company collection using microservices.
     *
     * @class MsCompanyCollection
     * @constructor
     */
    return Backbone.Collection.extend("MsCompanyCollection", {

        model: MsCompanyModel,

        initialize(models, options) {
            this.companyId = options.companyId;
        },

        url() {
            return `${Configuration.microserviceCompanyUrl}${this.companyId}/users`;
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/MsCompanyCollection.js